
import { defineComponent } from 'vue';
import BgImage from '@/views/public/landingpage/components/freelancer/BgImage.vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import useFreelancerLandingPage from '@/views/public/landingpage/components/freelancer/useFreelancerLandingPage';

export default defineComponent({
  name: 'FreelancerWelcome',
  components: { BCXMarkdown, BgImage },
  setup() {
    const { tl } = useFreelancerLandingPage();
    return { tl };
  }
});
